import { z } from 'zod';

export const autocompleteSchema = z.array(z.string());
